export const SYSTEM_SHUTDOWN = 'SYSTEM_SHUTDOWN';
export const SYSTEM_REBOOT = 'SYSTEM_REBOOT';
export const SYSTEM_LOADED = 'SYSTEM_LOADED';
export const SYSTEM_BOOT = 'SYSTEM_BOOT';
